export default __webpack_public_path__ + "static/media/videoCall.f6314865.svg";